﻿<template>
    <a-input :type="'tel'" v-model:value="props.value" v-model:disabled="props.disabled" maxlength="8" allow-clear
        @keypress="handleKeyPress($event)"
        @blur="onblur($event)"
        @change="onchange($event)"
        @focus="onfocus($event)"
    />
</template>

<script setup lang="ts">

    const props = defineProps({
        value: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    })

    const emit = defineEmits(['update:value']);

    const handleKeyPress = (event: any) => {
        let charCode = (event.which) ? event.which : event.keyCode;
        let dotIndex = event.target.value.indexOf('.');
        let cursorIndex = event.target.selectionStart;
        if ((charCode < 48 || charCode > 57) && (charCode !== 46 || dotIndex !== -1)) {
            event.preventDefault();
        }
        if(dotIndex !== -1) {
            let strArr:string[] = event.target.value.split('.');
            if(cursorIndex - 1 >= dotIndex && strArr[1].length == 2) {
                event.preventDefault();
            } else if (cursorIndex - 1 < dotIndex && strArr[0].length == 5) {
                event.preventDefault();
            } else {
                return true;
            }
        } else {
            if(event.target.value.length <= 6) {
                if((48 <= charCode && charCode <= 57) || (cursorIndex >= event.target.value.length - 2 && charCode === 46)) {
                    return true;
                } else {
                    event.preventDefault();
                }
            } else if(event.target.value.length == 7 && charCode === 46 && cursorIndex >= event.target.value.length - 2) {
                return true;
            } else {
                event.preventDefault();
            }
        }
    }

    const onblur = (event: any) => {
        if(event.target.value == null || event.target.value == '') {
            emit('update:value', '0.00');
            return;
        }

        let value = event.target.value;
        let dotIndex = value.indexOf('.');
        if(dotIndex == -1 && value.length > 5) {
            value = `${value.slice(0, 5)}.${value.slice(5)}`;
        }
        value = Intl.NumberFormat('ja-JP').format(Number.parseFloat(value));
        let strArr:string[] = value.split('.');
        if(strArr[1] == null || strArr[1].length == 0) {
            value = `${strArr[0]}.00`;
        } else if(strArr[1] != null && strArr[1].length == 1) {
            value = `${strArr[0]}.${strArr[1]}0`;
        }
        emit('update:value', value);
    }

    const onchange = (event: any) => {
        let value = event.target.value;
        if(value != '' && !value.startsWith('0.') && value != '0') {
            value = value.replace(/^0+/, '');
            if(value.startsWith('.')) {
                value = '0' + value;
            }
        }
        emit('update:value', value)
    }

    const onfocus = (event: any) => {
        event.target.value = event.target.value.replace(/,/g, '');
    }
</script>